<script setup lang="ts">
import { useAccountStore } from '@/store';
const accountStore = useAccountStore();
accountStore.logout();
</script>
